var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.rowUsed && _vm.rowUsed.length > 0)?_c('div',[_vm._v("\n  "+_vm._s(_vm.getLocalizedText(_vm.labels[_vm.type]))+"\n  "),_c('b-table',{ref:"rowUSed",attrs:{"responsive":"","outlined":"","striped":"","items":_vm.rowUsed,"fields":_vm.rowsUsedSeveralTimesFields}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }